import { render } from "./AnagraficaClientiAssegnati.vue?vue&type=template&id=30026ef8&scoped=true"
import script from "./AnagraficaClientiAssegnati.vue?vue&type=script&lang=js"
export * from "./AnagraficaClientiAssegnati.vue?vue&type=script&lang=js"

import "./AnagraficaClientiAssegnati.vue?vue&type=style&index=0&id=30026ef8&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30026ef8"]])

export default __exports__